
import empty from '@/views/default/empty'
export default [
  {
    path: '/ap',
    name: 'AP',
    component: empty,
    children: [
      {
        path: "clear-remitted-payment-query",
        name: "AP_INQUIRY_CLEAR_REMITTED_PAYMENT_SUMMARY_QUERY",
        meta: { tag: "toVue3" },
        component: empty,
      },
      {
        path: "clear-remitted-payment",
        name: "AP_INQUIRY_CLEAR_REMITTED_PAYMENT",
        meta: { tag: "toVue3" },
        component: empty,
      },
      {
        path: "display-vendor-invoice",
        name: "AP_INQUIRY_DISPLAY_VENDOR_INVOICE",
        meta: { tag: "toVue3" },
        component: empty,
      },
      {
        path: "invoice-to-be-due-for-payment",
        name: "AP_INQUIRY_INVOICE_TO_BE_DUE_FOR_PAYMENT",
        meta: { tag: "toVue3" },
        component: empty,
      },
      {
        path: "list-of-payment-block",
        name: "AP_INQUIRY_LIST_OF_PAYMENT_BLOCK",
        meta: { tag: "toVue3" },
        component: empty,
      },
      {
        path: "ers-report-query",
        name: "AP_INQUIRY_ERS_REPORT_QUERY",
        meta: { tag: "toVue3" },
        component: empty,
      },
      {
        path: "good-received-and-not-post-to-ap",
        name: "AP_INQUIRY_GOOD_RECEIVED_AND_NOT_POST_TO_AP",
        meta: { tag: "toVue3" },
        component: empty,
      },
      {
        path: "waiting-confirm-invoice",
        name: "AP_INQUIRY_WAITING_CONFIRM_INVOICE",
        meta: { tag: "toVue3" },
        component: empty,
      },
      {
        path: "confirmed-invoice-query",
        name: "AP_INQUIRY_CONFIRMED_INVOICE_QUERY",
        meta: { tag: "toVue3" },
        component: empty,
      }
    ]
  },
]
